<template>

    <!-- SIDEBAR -->
    <div class="sidebar" @click="panelDown($event)">

        <!-- CONTROLS -->
        <ul class="controls">
            <!-- ZOOM IN -->
            <li>
                <a @click="zoomIn" title="Zoom In" :class="{ active: (zoomed), disabled: (surging) }">
                    <span class="icon"><i class="icon-MBR_zoom-in" aria-hidden="true"></i></span>
                </a>
            </li>
            <!-- ZOOM OUT -->
            <li>
                <a @click="zoomOut" title="Zoom Out" :class="{ active: (!zoomed), disabled: (surging) }">
                    <span class="icon"><i class="icon-MBR_zoom-out" aria-hidden="true"></i></span>
                </a>
            </li>
            <li class="divider"></li>
            <!-- SHARE -->
            <li>
                <a @click="shareApp" title="Share">
                    <span class="icon"><i class="icon-MBR_share" aria-hidden="true"></i></span>
                </a>
                <share-controls></share-controls>
            </li>
            <li v-if="pdfDownload" class="divider"></li>
            <!-- DOWNLOAD -->
            <li v-if="pdfDownload">
                <a v-bind:href="pdfDownload" @click="trackEvent('PDF Download', pdfDownload)" title="Download PDF" target="_blank">
                    <span class="icon"><i class="icon-MBR_download" aria-hidden="true"></i></span>
                </a>
            </li>
            <li class="divider" v-if="(aboutPosition === 'sidebar')"></li>
            <!-- ABOUT -->
            <li>
                <a @click="togglePanel('panel-content-about', 'about-us', $event)" v-if="(aboutPosition === 'sidebar')" title="About">
                    <span class="icon"><i class="icon-MBR_information" aria-hidden="true"></i></span>
                </a>
            </li>
        </ul>
        <!-- END CONTROLS -->

    </div>
    <!-- END SIDEBAR -->

</template>


<script>

    import ShareControls from "./ShareControls.vue";

    let vm = {};

    export default {

        name: 'sidebar-controls',

        components: {
            ShareControls
        },

        data() {
            return {

            }
        },

        computed: {

            aboutPosition() {
                return this.$dataStore.getters.getAboutPosition;
            },

            zoomed() {
                return this.$dataStore.getters.getZoomedState;
            },

            surging() {
                return this.$dataStore.getters.getPowerSurgeState;
            },

            pdfDownload() {
                return this.$dataStore.getters.getCompanyPDF;
            }

        },

        created() {
            //console.info('%cSidebarControls::created', 'color:dodgerblue;');
            //console.log(this.$dataStore.state.company);
        },

        mounted() {
            //console.info('%cSidebarControls::mounted', 'color:green;');

            vm = this;

            vm.$eventBus.$emit('residence:resize');

            setTimeout(function() {
                vm.$eventBus.$emit('controls:entered');
            }, 300);
        },

        methods: {

            /**
             * @method togglePanel
             * @description
             * @param {String} type
             */
            togglePanel(type, slug, evt) {
                //console.info('%ctogglePanel', 'color:orange;');

                if (this.$dataStore.getters.getPowerSurgeState) {
                    this.$dataStore.dispatch('POWER_SURGE_OVERLAY', { val: false });
                    this.$dataStore.dispatch('POWER_SURGE', { val: false });
                    this.$dataStore.dispatch('POWER_SURGE_STATE', { val: false });
                    this.$eventBus.$emit('power-surge:end');
                }

                switch(type) {
                    case 'panel-content-about':
                        vm.trackEvent('About Button', 'Sidebar');
                        break;
                }

                this.$eventBus.$emit('panel:toggle', { panel: type, slug: slug });
            },

            /**
             * @method zoomIn
             * @description
             */
            zoomIn() {
                //console.info('%czoomIn', 'color:orange;');
                if (this.surging) { return; }
                vm.trackEvent('Zoom Button', 'In');
                this.$eventBus.$emit('panel:close');
                this.$eventBus.$emit('residence:zoomin');
                this.$dataStore.dispatch('ZOOM_INTERACTIVE', { val: true });
            },

            /**
             * @method zoomOut
             * @description
             */
            zoomOut() {
                //console.info('%czoomOut', 'color:orange;');
                if (this.surging) { return; }
                vm.trackEvent('Zoom Button', 'Out');
                this.$eventBus.$emit('panel:close');
                this.$eventBus.$emit('residence:zoomout');
                this.$dataStore.dispatch('ZOOM_INTERACTIVE', { val: false });
            },

            /**
             * @method shareApp
             * @description
             */
            shareApp() {
                //console.info('%cshareApp', 'color:orange;');
                this.$eventBus.$emit('panel:close');
                this.$eventBus.$emit('share:toggle');
            },

            /**
             * @method downloadDocs
             * @description
             */
            downloadDocs() {
                //console.info('%cdownloadDocs', 'color:orange;');
                this.$eventBus.$emit('panel:close');
                this.$eventBus.$emit('download:document');
                confirm('Download Document...');
            },

            panelDown(evt) {
                evt.stopPropagation();
            },

            trackEvent(action, label) {
                gtag('event', action, {
                    'event_category': 'MBRe: Residential',
                    'event_label': label || ''
                });
            }

        },

        events: {

        }

    }

</script>


<style lang="scss" scoped>

    @import '../assets/styles/helpers/variables';

    .sidebar {
        background-color: rgba(41,41,41, 1.0);
        width: 100%;
        max-width: 70px;
        padding: 20px 0;
        box-shadow: 0 2px 4px $black-50;
        flex: 0 0 70px;
        z-index: 5;
    }

    .controls {
        list-style-type: none;
        margin: 0 0 0 0;
        padding: 0 0 0 0;

        & > li {
            text-align: center;
            margin: 0 0 10px 0;
            padding: 0 0 0 0;
            position: relative;

            &:first-of-type {
                margin: 0 0 20px 0;
            }

            &.divider {
                background-color: var(--color-divider);
                font-size: 0;
                height: 1px;
                margin: 20px 0;
            }

            & > a {
                font-weight: normal;
                color: $white-100;
                display: block;
                text-decoration: none;

                /*@media (hover:hover) {*/
                    &:hover {
                        color: darken($white-100, 30%);
                    }
                /*}*/

                &.active {
                    color: darken($white-100, 30%);
                }

                &.disabled {
                    color: darken($white-100, 30%) !important;
                    pointer-events: none;
                }

                & > .icon {
                    font-size: 24px;

                    & > i {
                        display: block;
                        overflow: hidden;
                    }
                }
            }
        }
    }

</style>


// WEBPACK FOOTER //
// SidebarControls.vue?f00b8a6a